import { AdditionalCostDetails } from 'components/templates/settlement/ChildSettlementDetails/AdditionalCostList/AdditionalCostItem/AdditionalCostDetails/AdditionalCostDetails';
import { AdditionalCostDetailsDto, ChildId } from 'types';
import { DetailsFrameBase } from '../../../../../atoms';
import { AppCardList } from '../../../../../organisms';
import { settlementTexts } from '../../../../../../consts/text';
import { ParentAdditionalCostSplitDetails } from './ParentAdditionalCostSplitDetails/ParentAdditionalCostSplitDetails';

type Props = {
    childId: ChildId;
    detailsDto: AdditionalCostDetailsDto;
    index: number;
};

export const ParentAdditionalCostItem = ({ childId, detailsDto, index }: Props) => {
    return (
        <DetailsFrameBase key={detailsDto.id} hideHeader>
            <AdditionalCostDetails detailsDto={detailsDto} index={index} />
            <AppCardList
                marginTop={16}
                title="Podział kosztów"
                isHiddenAddButton
                dataSource={detailsDto.costSplits ?? []}
                emptyInfo={settlementTexts.children.costAllocation.emptyInfo}
                renderItem={(record, idx) => {
                    return (
                        <ParentAdditionalCostSplitDetails
                            childId={childId}
                            key={idx}
                            detailsDto={detailsDto}
                            idx={idx}
                            record={record}
                        />
                    );
                }}
            />
        </DetailsFrameBase>
    );
};
